import React, { useCallback, useContext, useEffect, useState } from "react";
import { Container } from "components";
import Breadcrumb from "components/molecules/Breadcrumb";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getData, putData } from "actions";
import { API_URL_alertNoticeSetting } from "constants/api";
import { alertNoticeSettingReducers } from "redux/alertNoticeSettingSlice";
import { AuthContext } from "context/AuthContext";
import { FaRegQuestionCircle } from "react-icons/fa";
import { Tooltip } from "react-tooltip";

const Alertandnotice = () => {
  const navigate = useNavigate();
  const [adminAccess, setAdminAccess] = useState(false);
  const { datauser } = useContext(AuthContext);
  const dispatch = useDispatch();
  const [ticketStatus, setTicketStatus] = useState("");
  const [adminEmail, setAdminEmail] = useState(0);
  const [departmentMember, setDepartmentMember] = useState("");
  const [agent, setAgent] = useState("");
  const [teamMember, setTeamMember] = useState("");
  const [assignmentStatus, setAssignmentStatus] = useState("");

  const {
    getAlertNoticeSettingResult,
    addAlertNoticeSettingResult,
  } = useSelector((state) => state.alertNoticeSetting);

  const get = useCallback(
    async (params) => {
      getData(
        API_URL_alertNoticeSetting,
        params,
        { dispatch, redux: alertNoticeSettingReducers },
        "GET_ALERTNOTICESETTING"
      );
    },
    [dispatch]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      ticket_status: ticketStatus,
      assignment_status: assignmentStatus,
      ticket_admin_email: adminEmail,
      assignment_assigned_agent: agent,
    };
    //edit on id 1
    putData(
      `${API_URL_alertNoticeSetting}1/`,
      formData,
      { dispatch, redux: alertNoticeSettingReducers },
      "ADD_ALERTNOTICESETTING",
      () => {
        fetchData();
      }
    );
  };

  const fetchData = useCallback(() => {
    //get id 1 for setting
    const params = `1/`;
    get(params);
  }, [get]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (addAlertNoticeSettingResult) {
      fetchData();
    }
  }, [addAlertNoticeSettingResult, fetchData]);

  useEffect(() => {
    if (getAlertNoticeSettingResult) {
      setTicketStatus(getAlertNoticeSettingResult.ticket_status);
      setAssignmentStatus(getAlertNoticeSettingResult.assignment_status);
      setAdminEmail(getAlertNoticeSettingResult.ticket_admin_email);
      setAgent(getAlertNoticeSettingResult.assignment_assigned_agent);
    }
  }, [getAlertNoticeSettingResult]);

  useEffect(() => {
    if (datauser !== "") {
      const permissionViewMenuAdmin = datauser.group_permissions.includes(
        "access_menu_admin"
      );
      if (permissionViewMenuAdmin) {
        setAdminAccess(true);
      } else {
        navigate("/dashboard/agent");
      }
    }
  }, [datauser]);

  if (!adminAccess) {
    return null;
  }

  return (
    <Container>
      <Breadcrumb
        title={"Settings"}
        excludedPaths={["tickets", "administrator"]}
        group={"Superadmin"}
      />
      <div className="bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow">
        <form onSubmit={handleSubmit}>
          <div className="h-12 w-full grid items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600 text-xs md:text-base">
            Alert and notice settings
          </div>

          <div className="p-4 grid grid-cols-12 gap-4 mb-4">
            <div className="bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow pb-4 overflow-x-auto col-span-full md:col-span-6 md:col-start-1 lg:col-span-6 lg:col-start-1">
              <div className="h-12 w-full flex  items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
                New ticket alert
                <span
                  className="ml-4 text-blue-700"
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content="New ticket alert to Agent, after Client create ticket"
                  data-tooltip-place="left"
                >
                  <FaRegQuestionCircle />
                </span>
              </div>
              <div className="flex items-center mt-3">
                <span className="ml-3 font-medium sm:text-sm mr-2">
                  Status:
                </span>
                <label className="inline-flex items-center">
                  <input
                    id="ticket_status1"
                    type="radio"
                    checked={ticketStatus === 1}
                    onChange={() => setTicketStatus(1)}
                    className="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                  />
                  <span className="ml-2">Enable</span>
                </label>
                <label className="inline-flex items-center ml-2">
                  <input
                    id="ticket_status0"
                    type="radio"
                    checked={ticketStatus === 0}
                    onChange={() => setTicketStatus(0)}
                    className="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out sm:ml-2 md:ml-2 lg:ml-3"
                  />
                  <span className="ml-2">Disable</span>
                </label>
              </div>
              <div className="flex items-center mt-3">
                <label className="inline-flex items-center ml-2">
                  <input
                    id="admin_email"
                    name="admin_email"
                    type="checkbox"
                    checked={adminEmail === 1}
                    onChange={() => setAdminEmail(adminEmail === 1 ? 0 : 1)}
                    className="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out sm:ml-2 md:ml-2 lg:ml-3"
                  />
                  <span className="ml-2">
                    Send emails to agents who have email info permission
                  </span>
                </label>
              </div>
            </div>

            <div className="bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow pb-4 overflow-x-auto col-span-full md:col-span-6 md:col-start-7 lg:col-span-6 lg:col-start-7">
              <div className="h-12  w-full flex items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
                Ticket assignment alert
                <span
                  className="ml-4 text-blue-700"
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content="Notification of assigning tickets to Agents, after Admin assigns them"
                  data-tooltip-place="left"
                >
                  <FaRegQuestionCircle />
                </span>
              </div>

              <div className="flex items-center mt-3">
                <span className="ml-3 font-medium sm:text-sm mr-2">
                  Status:
                </span>
                <label className="inline-flex items-center">
                  <input
                    id="assignedstatus1"
                    type="radio"
                    checked={assignmentStatus === 1}
                    onChange={() => setAssignmentStatus(1)}
                    className="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                  />
                  <span className="ml-2">Enable</span>
                </label>
                <label className="inline-flex items-center ml-2 ">
                  <input
                    id="assignedstatus0"
                    type="radio"
                    value="option2"
                    checked={assignmentStatus === 0}
                    onChange={() => setAssignmentStatus(0)}
                    className="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out sm:ml-2 md:ml-2 lg:ml-3"
                  />
                  <span className="ml-2">Disable</span>
                </label>
              </div>
              <div className="flex items-center mt-3">
                <label className="inline-flex items-center ml-2">
                  <input
                    id="agent"
                    name="agent"
                    type="checkbox"
                    checked={agent === 1}
                    onChange={() => setAgent(agent === 1 ? 0 : 1)}
                    className="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out sm:ml-2 md:ml-2 lg:ml-3"
                  />
                  <span className="ml-2">Send Email to Agent Assign</span>
                </label>
              </div>
            </div>
          </div>

          <div className="h-12 w-full grid items-center px-4 bg-neutral-50 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            <button
              type="submit"
              className="w-20 items-center p-1 px-3 rounded shadow-sm border text-white bg-blue-800 hover:bg-blue-700"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
      <Tooltip id="my-tooltip" />
    </Container>
  );
};

export default Alertandnotice;
